<template ref="playlistT">
  <main :key="rerender" class="playlist">
    <SimpleHeader route="/main">
      <template v-slot:title>
        <span>
          {{ $ml.get("משחקים בכיף") }}
        </span>
      </template>
      <span slot="additional">
        <sidebar-toggler />
        <router-link :to="'/'" class="home-anchor" style="color: white;">
          <svg
                    width="22"
                    height="20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="position:absolute; top: 4px; right: 24px;"
                  >
                    <path
                      d="M10.3312 0.926701L10.2632 0.863573L10.1951 0.926701L0.931976 9.52313L0.85877 9.59106L0.926614 9.66436L1.78441 10.591L1.85245 10.6645L1.92585 10.5964L2.59093 9.9786V17V17.1H2.69093H9.00112H9.10112V17V10.7907H11.4252V17V17.1H11.5252H17.8354H17.9354V17V9.9786L18.6005 10.5964L18.6739 10.6645L18.7419 10.591L19.5997 9.66436L19.6675 9.59106L19.5943 9.52313L10.3312 0.926701ZM16.4733 8.6246V15.6381H12.8872V9.42883V9.32883H12.7872H7.73908H7.63908V9.42883V15.6381H4.05297V8.6246L10.2632 2.85187L16.4733 8.6246Z"
                      fill="white"
                      stroke="white"
                      stroke-width="0.2"
                    />
                  </svg>
        </router-link>
      </span>
    </SimpleHeader>
    <app-loading v-if="loading.sync" :loading="false" class="sm-cont" style="position:relative">
      <div style="position:relative; padding: 3px 5px; border-radius: 4px; max-height: 720px !important; margin-top: 33px;">
        <div style="position: absolute;width: 130px !important;top: -23px;right: 16px;z-index: 9999;" class="line h17 w40 m10"></div>
        <div style="position: absolute;width: 130px !important;top: -23px;left: 16px;z-index: 9999;" class="line h17 w40 m10"></div>
        <div class="btn-skelet" style="position: absolute;left: 12px;bottom: -39px;"></div>
              <div class="btn-skelet" style="position: absolute;right: 12px;bottom: -39px;"></div>
              <div class="btn-skelet-circle" style="position: absolute;bottom: -39px; right: 0;left: 0;margin-left: auto;margin-right: auto;"></div>
              <div
                class="card-wrapper"
                id="playlist_cards_container"
                style="max-height: 541px;"
              >
                  <div class="icon-wrapper">
                    <div class="circle"></div>
                  </div>
                </div>
              </div>
    </app-loading>
    <app-loading v-else class="sm-cont">
      <div class="settings-wrapper">
        <SettingsBlock :dots="dots" :muted="muted" />
        <!-- <HelpPopup keyValue="playlistFirstTime" /> -->
        <div v-if="dots.sevens && muted" class="help-popup-sevens fade-scale">
        <div class="info-wrapper ">
          <div style="padding-top: 18px; padding-bottom:2px; text-align: center;">
            <svg width="30" height="40" viewBox="0 0 27 35" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.3833 1L18.6871 1.23205L21.0334 3.62987L13.2727 3.8877L13.5048 4.60962L21.2654 4.35179L18.9192 6.77539L19.1512 7.49732L22.6577 3.8877L19.3833 1ZM10.153 3.86191L2.39228 4.11974L4.73853 1.69614L4.50648 1L1 4.60962L4.30022 7.47153L4.99636 7.23949L2.65011 4.86745L10.4108 4.60962L10.153 3.86191Z" fill="#00465B" stroke="#00465B" stroke-linejoin="bevel"/>
              <path d="M18.7365 34.0007C17.1637 34.0007 15.8746 33.9749 15.7457 33.9749H15.4621L15.4105 33.6913C15.4105 33.6913 15.2816 33.3303 14.3276 32.0412C13.7604 31.2934 13.1674 30.5973 11.6204 29.1792C10.7696 28.4057 9.53197 27.2713 8.62957 26.472C8.16547 26.0595 7.77873 25.7243 7.62403 25.5696C7.05681 25.0282 5.50983 23.6359 6.48958 22.3725C7.44355 21.2639 10.7438 22.914 12.4197 23.8679C12.0845 21.2123 10.95 12.0336 10.7696 10.7444C10.5117 8.78489 11.4399 8.24346 12.0329 8.11454C12.9869 7.88249 13.6315 8.70755 13.8377 9.17164L13.8635 9.27478L15.1784 17.4222C15.2558 17.2675 15.3331 17.1386 15.4363 17.0097C15.7457 16.5714 16.2098 16.3393 16.7512 16.262C17.7825 16.1331 18.4529 16.9323 18.8396 17.6027C18.9428 17.4222 19.0975 17.2675 19.2779 17.1386C19.6131 16.9323 19.9999 16.855 20.4382 16.9581C21.2375 17.1644 21.7015 17.8089 21.9594 18.3762C22.243 18.0152 22.6813 17.7058 23.3774 17.6027C23.79 17.5511 24.1509 17.6542 24.4603 17.8863C25.1049 18.402 25.208 19.3817 25.2338 19.4848L25.9557 25.0797C26.162 26.6525 25.4401 28.5604 24.8213 30.2363C24.3314 31.5255 23.8931 32.7373 23.9704 33.4592L24.022 33.8202L23.6611 33.8717C22.475 33.9749 20.4382 34.0007 18.7365 34.0007ZM16.0035 33.253C17.009 33.2787 21.1601 33.3303 23.2227 33.1498C23.2485 32.299 23.6611 31.1903 24.1251 29.9527C24.7182 28.3542 25.3885 26.5236 25.2338 25.1313L24.5119 19.5364C24.4861 19.3044 24.3572 18.6856 24.022 18.4277C23.8673 18.2988 23.6868 18.273 23.4806 18.2988C22.3977 18.4277 22.3203 19.3044 22.2946 19.4075L21.5726 19.4591C21.5726 19.4333 21.289 17.8863 20.2577 17.6285C20.0257 17.5769 19.8452 17.6027 19.6905 17.7058C19.3811 17.9121 19.2522 18.402 19.2264 18.5824L18.5302 18.6598C18.5302 18.634 17.9372 16.855 16.8286 16.9839C16.4676 17.0355 16.2098 17.1901 16.0035 17.448C15.3589 18.2988 15.591 19.9489 15.6425 20.2841L15.6683 20.3872L14.9464 20.5162L14.9206 20.413L13.1674 9.48104C13.0642 9.24899 12.7033 8.68177 12.1876 8.7849C11.5946 8.91381 11.3626 9.5326 11.4915 10.6155C11.672 12.1367 13.2189 24.461 13.2189 24.461L13.3221 25.2087L12.6775 24.8219C10.3312 23.4039 7.5209 22.2694 7.05681 22.8108C6.79898 23.146 6.67006 23.7133 8.11391 25.0282C8.29439 25.1829 8.65535 25.5181 9.11945 25.9306C10.0219 26.7299 11.2852 27.8643 12.1103 28.6378C13.683 30.1074 14.3018 30.8294 14.8948 31.6028C15.5394 32.4795 15.8488 32.9693 16.0035 33.253Z" fill="#00465B" stroke="#00465B" stroke-linejoin="bevel"/>
            </svg>
          </div>
          <div class="info-element border">
            <span>{{$ml.get("החליקו ימינה למשחקים בהם שיחקתם ושמאלה לאלה שלא")}}</span>
          </div>
          <div style="height: 100%; width:100%; direction: ltr !important;">
            <div class="controll-info">
              <button @click="handleCustomChange" class="button-info">מתחילים</button>
            </div>
            <div class="buttons-info" style="margin-left: 65px !important;">
              <div class="dots" :class="!dots.sevens?'dots-simple':'dots-active'"></div>
              <div class="dots" :class="!dots.fifth?'dots-simple':'dots-active'"></div>
              <div class="dots" :class="!dots.sixth?'dots-simple':'dots-active'"></div>
            </div>
          </div>
        </div>
      </div>
        <div v-if="dots.fifth && muted" class="help-popup-fifth fade-scale">
        <div class="info-wrapper ">
          <div class="info-element border">
            <span>{{$ml.get("בחירת מיקום, סיטואציה וגיל לקבלת משחקים מתאימים")}}</span>
          </div>
          <div style="height: 100%; width:100%; direction: ltr !important;">
            <div class="controll-info">
              <button @click="handleCustomChange" class="button-info">הבא</button>
            </div>
            <div class="buttons-info" style="margin-left: 60px !important;">
              <div class="dots" :class="!dots.sevens?'dots-simple':'dots-active'"></div>
              <div class="dots" :class="!dots.fifth?'dots-simple':'dots-active'"></div>
              <div class="dots" :class="!dots.sixth?'dots-simple':'dots-active'"></div>
            </div>
          </div>
        </div>
      </div>
      </div>

      <template
        :style="!loading.next ? 'pointer-events:none' : ''"
        v-if="!loading.sync"
      >
        <div
          class="card-wrapper"
          id="playlist_cards_container"
          @mousedown="onMouseDown"
          @touchstart="onMouseDown"
          :style="muted? 'pointer-events: none;':'pointer-events: all;'"
        >
          <template v-for="(item, i) in data">
            <CardGame
              @customChange="handleCustomChange"
              :dots="dots" :muted="muted"
              :data="item"
              :indexs="i"
              v-if="item && item.id_playlist"
              :key="item._uuid"
              :first="i == data.length - 1"
            />
          </template>
        </div>

        <div class="buttons">
          <app-btn class="next" @click="next(false)">
            <div style="width: 100%; position: relative;" >
              <span style="margin-right: 8px;">{{ $ml.get("שחקתי") }}</span>
              <svg style="position: absolute; top: 0px; right: -19px;" height="20" viewBox="0 0 48 48" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48h-48z" fill="none"/><path d="M18 32.34l-8.34-8.34-2.83 2.83 11.17 11.17 24-24-2.83-2.83z"/></svg>


            </div>
          </app-btn>

          <LikeButton @customChange="handleCustomChange" :dots="dots" :muted="muted" @click="like" :item="currentItem" />

          <app-btn class="prev" @click="skip(false)">
            <div style="width: 100%; position: relative;" >
              <span style="margin-right: 0px;">{{ $ml.get("לא שחקתי") }}</span>
              <svg style="position: absolute; top: 5px; right: -19px;" width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.59376 1L1.59375 9" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
              <path d="M1.59375 1L9.59376 9" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
              </svg>

            </div>

          </app-btn>
        </div>
      </template>
    </app-loading>

    <!-- <GiftLine v-if="settings.section != 'adult'" ref="giftline" /> -->
    <div v-if="loading.sync" class="bottom-skelet"></div>
    <AddYourGame
      v-else-if="
        $route.params.gifts === undefined ||
        $store.getters['user/data'].position === 'student' ||
        $store.getters['user/data'].position === 'parent'
      "
    />
    
    <!-- <TeacherGuide v-else /> -->
    <TeacherPlaylistFirst/>
  </main>
</template>

<script>
import Card from "@/components/playlist/Card.vue";
import CardGame from "@/components/playlist/card-game/CardGame";
import ShareButton from "@/components/playlist/ShareButton.vue";
import CardDummy from "@/components/playlist/CardDummy.vue";
import GameIdea from "@/components/GameIdea.vue";
// import GiftLine from "@/components/GiftLine.vue";
import SimpleHeader from "@/components/SimpleHeader.vue";
import GameHeader from "@/components/GameHeader.vue";
import SidebarToggler from "@/components/SidebarToggler.vue";
import WannaSubscribe from "@/components/modals/WannaSubscribe.vue";
import Subscribe from "@/components/modals/Subscribe.vue";
import NoGamesFound from "@/components/modals/NoGamesFound.vue";
import GamesEnded from "@/components/modals/GamesEnded.vue";
import LikeButton from "@/components/playlist/LikeButton";
import SettingsBlock from "@/components/playlist/SettingsBlock";
import SuggestGameVue from "@/components/modals/SuggestGame.vue";
// import HelpPopup from "@/components/playlist/HelpPopup";
import AddYourGame from "@/components/playlist/AddYourGame";
import TeacherGuide from "@/components/playlist/TeacherGuide";
import { mapGetters } from "vuex";
import { PlaylistAPI,UserAPI } from "@/api";
import TeacherPlaylistFirst from "@/components/modals/modal/TeacherPlaylistFirst";
import DefaultUserInactiveVue from '@/components/modals/defaultUser/DefaultUserInactive.vue';
import DefaultUserToRegVue from '@/components/modals/defaultUser/DefaultUserToReg.vue';

export default {
  data() {
    return {
      id_category: null,
      index: 0,
      viewed: "",
      rerender: 0,
      teacherViewed: 0,
      subscribeModal: false,
      loading: {
        next: false,
        sync: false,
      },
      dots:{
            first:false,
            second:false,
            third:false,
            fourh:false,
            fifth:false,
            sixth:false,
            sevens:false,
      },
      muted:false
    };
  },
  watch: {
    settings() {
      this.rerender = true;
    },
    index(to) {
      if (!this.$route.params.infinity && (this.$store.getters["user/data"].position=="teacher")) {
        if (to % 13 == 0 && !localStorage.getItem("subs_block")) {
        }
      }
      // else if (!this.payment_showed && !this.$store.getters["user/hasSubs"]) {

      //   this.$modal.show(
      //     Subscribe,
      //     {},
      //     {
      //       height: "auto",
      //       adaptive: true,
      //       scrollable: true
      //     },
      //     {
      //       'closed': () => {
      //         this.payment_showed = false;
      //       }
      //     }
      //   );
      // }
    },
    currentItem: function (to, from) {
      if (!this.$route.params.infinity && (this.$store.getters["user/data"].position=="teacher")) {
        if (!to || (from && to._uuid === from._uuid)) {
          return;
        }

        this.processCurrentItem(to);
      }
    },
  },
  components: {
    TeacherPlaylistFirst,
    Card,
    CardGame,
    GameIdea,
    // GiftLine,
    SimpleHeader,
    GameHeader,
    SidebarToggler,
    CardDummy,
    ShareButton,
    LikeButton,
    SettingsBlock,
    // HelpPopup,
    AddYourGame,
    TeacherGuide,
    SuggestGameVue
  },
  computed: {
    ...mapGetters({
      data: "playlist/data",
      orderIndex: "playlist/orderIndex",
      settings: "playlist/settings",
      count: "playlist/count",
      random: "playlist/random",
      currentItem: "playlist/currentItem",
      user: "user/data",
      playlistCount: "counter-game/getPlaylistCount",
      playlistCounter: "user/getPlaylistCounter",
      shootlistCounter: "user/getShootlistCounter",
      isDefaultUser: "user/getDefaultUser",
      playlistDefaultCount :"userDefault/getDefaultUserTotalPL",
      playlistDefaultCurrentCount:"userDefault/getDefaultUserCurrentPL",
      shootlistDefaultCount:"userDefault/getDefaultUserTotalSL",
      shootlistDefaultCurrentCount:"userDefault/getDefaultUserCurrentSL"
    }),
  },
  watch:{
    playlistCount:{
      handler(val, oldVal) {
        if(this.playlistCount>=6 && this.$store.getters['user/data'].isPlaylistPopupShown==false)
        {
          this.startBubbles();
        }
      },
      deep: true
    },
    playlistDefaultCurrentCount:{
      handler(val,oldVal)
      {
        if(this.isDefaultUser==true)
        {
          let viewed = localStorage.getItem('bubbles_shown');
          if(this.playlistDefaultCurrentCount>=6 && viewed==null)
            {
              this.startBubbles();
            }
        }
      }
    }
  },
  methods: {
    handleCustomChange(){
     
      if(this.dots.fifth == true)
      {
        this.dots.fifth = false;
        this.dots.sixth = false;
        this.dots.sevens = true;
      }
      else if(this.dots.sixth == true)
      {
        this.dots.fifth = true;
        this.dots.sevens = false;
        this.dots.sixth = false;
      }
      else if(this.dots.sevens == true)
      {
        this.dots.fifth = false;
        this.dots.sixth = false;
        this.dots.sevens = false;
        this.muted = false;
        UserAPI.popPlaylistUpUpdate().then(()=>{
          this.$store.dispatch("user/updateData");
        })
        localStorage.setItem('bubbles_shown',true);
      }
    },
    processCurrentItem(to) {
      if (to.state == "give-money" && !this.subs_show) {
        // this.subs_show = true;
        // this.$modal.show(
        //   Subscribe,
        //   {},
        //   {
        //     height: "auto",
        //     adaptive: true,
        //     scrollable: true
        //   },
        //   {
        //     "before-close": () => {
        //       this.$router.replace("/main");
        //     },
        //     closed: () => {
        //       this.subs_show = false;
        //     }
        //   }
        // );
      } else {
        if (
          // !this.animating &&
          to &&
          //(to.order_index % this.count == 1 || this.count == 1) &&
          to.order_index > 1 &&
          this.random
        ) {
          this.$modal.show(
            GamesEnded,
            {},
            {
              height: "auto",
              width: 320,
              adaptive: true,
              scrollable: true,
            }
          );
        }
      }
    },
    getCurrentEl() {
      const cards = document.querySelectorAll(
        "#playlist_cards_container .card-game"
      );
      return cards[cards.length - 1];
    },
    getNextEl() {
      const cards = document.querySelectorAll(
        "#playlist_cards_container .card-game"
      );
      return cards[cards.length - 2];
    },
    onMouseDown(e) {
      if (!this.currentItem || this.loading.next || this.animating) return;

      var el = this.getCurrentEl();

      // TODO: ref.advertisment ||
      if (this.animating) return;

      this.vector_way = null;
      this.grapped = true;
      this.starting_x = e.x ? e.x : e.touches[0].clientX;
      this.starting_y = e.y ? e.y : e.touches[0].clientY;

      document.addEventListener("touchend", this.onMouseUp);
      document.addEventListener("touchmove", this.onMouseMove, {
        passive: false,
      });
      document.addEventListener("mouseup", this.onMouseUp);
      document.addEventListener("mousemove", this.onMouseMove, {
        passive: false,
      });
    },
    onMouseMove(e) {
      // // сделать кеширование селекторов
      if (!this.grapped) return;

      const el = this.getCurrentEl();

      var offset = (e.x ? e.x : e.touches[0].clientX) - this.starting_x;
      const vertical_offset =
        (e.y ? e.y : e.touches[0].clientY) - this.starting_y;

      if (!this.vector_way) {
        if (offset > 10 || offset < -10) {
          this.vector_way = "horizontal";
        } else if (vertical_offset > 10 || vertical_offset < -10) {
          this.vector_way = "vertical";
        }
      }

      if (this.vector_way == "horizontal") {
        el.classList.add("grapped");
        this.grapped = true;

        var translate = offset.map(0, el.offsetWidth, 0, 100);
        var rotate = offset.map(0, el.offsetWidth, 0, 60);
        el.style.transform = `translateX(${translate}%) rotate(${rotate}deg)`;

        var side = translate > 0 ? "left" : "right";
        var opacity = Math.abs(offset.map(0, el.offsetWidth / 2, 0, 1));

        el.getElementsByClassName("back-placeholder")[0].style.visibility =
          "hidden";
        el.getElementsByClassName("next-placeholder")[0].style.visibility =
          "hidden";

        if (side == "right") {
          el.getElementsByClassName("back-placeholder")[0].style.opacity =
            opacity;
          el.getElementsByClassName("back-placeholder")[0].style.visibility =
            "visible";
        } else {
          el.getElementsByClassName("next-placeholder")[0].style.opacity =
            opacity;
          el.getElementsByClassName("next-placeholder")[0].style.visibility =
            "visible";
        }

        e.preventDefault();
      }
    },
    async onMouseUp(e) {
      if (!this.grapped) return;

      var el = this.getCurrentEl();

      el.classList.remove("grapped");
      el.classList.add("swiping");
      var offset = (e.x ? e.x : e.changedTouches[0].clientX) - this.starting_x;
      var percentage = offset.map(0, el.offsetWidth, 0, 100);
      var side = percentage > 0 ? "left" : "right";
      percentage = Math.abs(percentage);

      this.animating = true;
      this.grapped = false;

      setTimeout(() => {
        this.animating = false;
        if (percentage < 50) {
          el.classList.remove("swiping", "swipe-right", "swipe-left");
        } else {
          this.$store.commit("playlist/deleteLastCard");
        }
      }, 1000);

      if (percentage >= 50) {
        if(this.$store.getters["user/isLoaded"])
      {
        let num = localStorage.getItem('playlist_freq')?localStorage.getItem('playlist_freq'):0;
        if(num<=0)
        {
          localStorage.setItem('playlist_freq', 1);
        }
        else
        {
          localStorage.setItem('playlist_freq', parseInt(num)+1);
          if(parseInt(num)+1>=this.$store.getters["user/data"].frequency.playlist)
          {
            localStorage.removeItem('playlist_freq');
            this.$modal.show(
              SuggestGameVue,
                    {},
                    {
                      height: "auto",
                      adaptive: true,
                      width: 360,
                    }
            );
          }
        }
      }
        if (side == "left") {
          el.classList.add("swipe-left");
          if (!this.currentItem.played) {
            this.setViewed();
            await this.$store.dispatch("playlist/throwActivity", "ans");
          }
        } else {
          el.classList.add("swipe-right");
          if (!this.currentItem.played) {
            this.setViewed();
            await this.$store.dispatch("playlist/throwActivity", "skp");
          }
        }
        this.teacherViewed++;
        this.checkFirstTeacher();
        if (!this.currentItem.played) {
          if(!this.$store.getters["user/checkSubs"] && this.$store.getters["user/data"].subscribe_games>0)
          {
          this.$store.commit('user/decreaseSubsGamesCounter');
          this.teacherViewed++;
          this.checkFirstTeacher();
          if(this.$store.getters['user/data'].isPlaylistPopupShown==false)
          {
            this.$store.commit('counter-game/increasePlaylist');
          }
          this.getRandomTotalGames({id_category: this.id_category});
          }
          else if(!this.$store.getters["user/checkSubs"])
          {
            this.$store.dispatch('user/decreaseGamesCounter');
            this.$store.commit('playlist/increaseGamePassedCounter');
            this.teacherViewed++;
            this.checkFirstTeacher();
            if(this.$store.getters['user/data'].isPlaylistPopupShown==false)
            {
              this.$store.commit('counter-game/increasePlaylist');
            }
            this.getRandom({
              id_category: this.id_category,
              neededCheck: true
            });
          }
          else
          {
            this.teacherViewed++;
            this.checkFirstTeacher();
            if(this.$store.getters['user/data'].isPlaylistPopupShown==false)
            {
              this.$store.commit('counter-game/increasePlaylist');
            }
            this.getRandom({
              id_category: this.id_category,
            neededCheck: false
          });
          }
        }

      } else {
        el.style.transform = "translateX(0) rotate(0)";
        el.getElementsByClassName("back-placeholder")[0].style.visibility = "";
        el.getElementsByClassName("next-placeholder")[0].style.visibility = "";
        el.getElementsByClassName("back-placeholder")[0].style.visibility = "";
        el.getElementsByClassName("next-placeholder")[0].style.visibility = "";
      }
      document.removeEventListener("touchend", this.onMouseUp);
      document.removeEventListener("touchmove", this.onMouseMove);
      document.removeEventListener("mouseup", this.onMouseUp);
      document.removeEventListener("mousemove", this.onMouseMove);
    },
    setViewed() {
      if (this.$route.params.infinity && (this.$store.getters["user/data"].position=="teacher") ) {
        this.$store.commit("playlist/pushViewedT", this.data[0].id_playlist);
        
      } else {
        this.$store.commit("playlist/pushViewed", this.data[0].id_playlist);
      }
      if(this.isDefaultUser)
      {
        this.addLocalStore();
      }
    },
    addLocalStore()
    {
      let arr = localStorage.getItem('playlists_before_reg');
      if(arr!=null && arr.length>0)
      {
        arr=arr.split(',')
        arr.push(this.data[0].id_playlist);
        localStorage.setItem('playlists_before_reg',arr);
      }
      else
      {
        let newArr = [];
        newArr.push(this.data[0].id_playlist);
        localStorage.setItem('playlists_before_reg',newArr);
      }
    },
    async next() {
      window.fbq('track','Play games');
      let el = this.getCurrentEl();

      // TODO: ref.advertisment
      if (this.loading.next || this.animating) {
        return;
      }

      this.animating = true;
      el.classList.add("animate", "animate-left");
      setTimeout(() => {
        this.animating = false;
        this.$store.commit("playlist/deleteLastCard");
      }, 2000);

      this.setViewed();
      if(this.$store.getters["user/isLoaded"])
      {
        let num = localStorage.getItem('playlist_freq')?localStorage.getItem('playlist_freq'):0;
        if(num<=0)
        {
          localStorage.setItem('playlist_freq', 1);
        }
        else
        {
          localStorage.setItem('playlist_freq', parseInt(num)+1);
          if(parseInt(num)+1>=this.$store.getters["user/data"].frequency.playlist)
          {
            localStorage.removeItem('playlist_freq');
            this.$modal.show(
              SuggestGameVue,
                    {},
                    {
                      height: "auto",
                      adaptive: true,
                      width: 360,
                    }
            );
          }
        }
      }
      this.$store.dispatch('playlist/throwActivity', 'ans').then(res=>{
        
        if(res==true)
        {
          this.$store.dispatch('user/decreaseGamesCounter');
          if(this.$store.getters['user/data'].isPlaylistPopupShown==false)
      {
        this.$store.commit('counter-game/increasePlaylist');
      }
          if(!this.$store.getters["user/checkSubs"] && this.$store.getters["user/data"].subscribe_games>0)
          {
          this.$store.commit('user/decreaseSubsGamesCounter');
          this.teacherViewed++;
          this.checkFirstTeacher();
          
          this.getRandomTotalGames({id_category: this.id_category});
          }
          else if(!this.$store.getters["user/checkSubs"])
          {
            this.$store.commit('playlist/increaseGamePassedCounter');
            this.teacherViewed++;
            this.checkFirstTeacher();
           
            this.getRandom({
              id_category: this.id_category,
              neededCheck: true
            });
          }
          else
          {
            this.teacherViewed++;
            this.checkFirstTeacher();
           
            this.getRandom({
              id_category: this.id_category,
            neededCheck: false
          });
          }
        }
      });
    },
    async skip() {
      window.fbq('track','Play games');
      const el = this.getCurrentEl();
      // TODO: ref.advertisment
      if (this.loading.next || this.animating) {
        return;
      }
      this.animating = true;
      el.classList.add("animate", "animate-right");
      setTimeout(() => {
        this.animating = false;
        this.$store.commit("playlist/deleteLastCard");
      }, 2000);
      this.setViewed();
      if(this.$store.getters["user/isLoaded"])
      {
        let num = localStorage.getItem('playlist_freq')?localStorage.getItem('playlist_freq'):0;
        if(num<=0)
        {
          localStorage.setItem('playlist_freq', 1);
        }
        else
        {
          localStorage.setItem('playlist_freq', parseInt(num)+1);
          if(parseInt(num)+1>=this.$store.getters["user/data"].frequency.playlist)
          {
            localStorage.removeItem('playlist_freq');
            this.$modal.show(
              SuggestGameVue,
                    {},
                    {
                      height: "auto",
                      adaptive: true,
                      width: 360,
                    }
            );
          }
        }
      }
      await this.$store.dispatch("playlist/throwActivity", "skp").then(res=>{
        if(res==true)
        {
          this.$store.dispatch('user/decreaseGamesCounter');
          if(this.$store.getters['user/data'].isPlaylistPopupShown==false)
      {
        this.$store.commit('counter-game/increasePlaylist');
      }
          if(!this.$store.getters["user/checkSubs"] && this.$store.getters["user/data"].subscribe_games>0)
          {
          this.$store.commit('user/decreaseSubsGamesCounter');
          this.teacherViewed++;
          this.checkFirstTeacher();
          
          this.getRandomTotalGames({id_category: this.id_category});
          }
          else if(!this.$store.getters["user/checkSubs"])
          {
            this.$store.commit('playlist/increaseGamePassedCounter');
            this.teacherViewed++;
            this.checkFirstTeacher();
           
            this.getRandom({
              id_category: this.id_category,
              neededCheck: true
            });
          }
          else
          {
            this.teacherViewed++;
            this.checkFirstTeacher();
           
            this.getRandom({
              id_category: this.id_category,
            neededCheck: false
          });
          }
        }
      });
      this.animating = false;
    },
    checkFirstTeacher() {
      if (
        !this.$store.getters["tutorials/isUsed"]("playlistTeacherFirst") &&
        this.$store.getters["user/isTeacher"] &&
        this.teacherViewed === 3
      ) {
        this.$store.commit("tutorials/setTutorial", "playlistTeacherFirst");
        this.$store.commit("modals/teacher-playlist-first/open");
        this.$store.dispatch("tutorials/updateData");
      }
    },
    getRandomTotalGames(data ={})
    {
      if(this.isDefaultUser && this.playlistDefaultCount == this.playlistDefaultCurrentCount)
      {
        this.$router.push('/main');
        this.$modal.show(
          DefaultUserToRegVue,
          {

          },
          {
            adaptive: true,
            height: "auto",
            width: 300
          }
        )
      }
      else
      {
        var id_school = this.$store.getters["user/data"].id_school;
      if ( id_school == null && this.playlistCounter < 1 && !this.$store.getters["user/checkSubs"] && !this.isDefaultUser && !this.$store.getters['sub/getDisabled']) 
      {
        this.$store.dispatch("user/defaultGamesCounter");
        this.$store.commit('user/setSub',true);
        this.$router.replace("/subsPlans");
        this.$store.commit("playlist/setViewed", []);
        // this.$store.commit("playlist/clearViewedSeen",[]);
        this.$store.commit('playlist/resetGamePassedCounter');
        this.$store.dispatch('user/updateData');
        this.$store.commit("playlist/setViewed", []);
        // this.$store.commit("playlist/clearViewedSeen",[]);
      }
      this.loading.next = true;
      if (this.$route.params.infinity && (this.$store.getters["user/data"].position=="teacher")) {
        data.gifts = this.$route.params.gifts;
        data.giftsOnly = true;
         data.previous_game = false;
      }
      return this.$store
        .dispatch("playlist/getRandom", data)
        .then((res) => {
          this.index++;
          if (this.random && !this.popup_showed) {
            this.$modal.show(
              NoGamesFound,
              {
                id_category: this.id_category
              },
              {
                height: "auto",
                width: 300,
              }
            );
            this.popup_showed = true;
          }
          return res;
        })
        .catch(()=>{
          // this.$store.dispatch('user/updateData');
          // this.$store.commit("playlist/setViewed", []);
        })
        .finally(() => {
          this.loading.next = false;
        });
      }
    },
    getRandom(data = {}) {
      if(this.isDefaultUser && this.playlistDefaultCount == this.playlistDefaultCurrentCount)
      {
        this.$router.push('/main');
        this.$modal.show(
          DefaultUserToRegVue,
          {

          },
          {
            adaptive: true,
            height: "auto",
            width: 300
          }
        )
      }
      else
      {
      if(data.neededCheck==true)
      {
        var id_school = this.$store.getters["user/data"].id_school;
      if (id_school == null && this.playlistCounter < 1 && !this.$store.getters["user/checkSubs"] && !this.isDefaultUser && !this.$store.getters['sub/getDisabled'] ) {
        this.$store.commit('user/setSub',true);
        this.$store.dispatch("user/defaultGamesCounter");
        this.$router.replace("/subsPlans");
        this.$store.commit("playlist/clearStorage");
        this.$store.commit("playlist/setViewed", []);
        // this.$store.commit("playlist/clearViewedSeen",[]);
        this.$store.commit('playlist/resetGamePassedCounter');
        this.$store.dispatch('user/updateData');
        this.$store.commit("playlist/setViewed", []);
        // this.$store.commit("playlist/clearViewedSeen",[]);
      }
      }
      this.loading.next = true;
      if (this.$route.params.infinity && (this.$store.getters["user/data"].position=="teacher")) {
        data.gifts = this.$route.params.gifts;
        data.giftsOnly = true;
         data.previous_game = false;
      }
      return this.$store
        .dispatch("playlist/getRandom", data)
        .then((res) => {
          this.index++;
          if (this.random && !this.popup_showed) {
            this.$modal.show(
              NoGamesFound,
              {
                id_category: this.id_category
              },
              {
                height: "auto",
                width: 300,
              }
            );
            this.popup_showed = true;
          }
          return res;
        })
        .catch(()=>{
          // this.$store.dispatch('user/updateData');
          // this.$store.commit("playlist/setViewed", []);
        })
        .finally(() => {
          this.loading.next = false;
        });
      }
    },
    loadState() {
      return this.$store.dispatch("playlist/loadState");
    },
    like() {
      if(this.isDefaultUser)
      {
        this.$modal.show(
          DefaultUserInactiveVue,
          {

          },
          {
            adaptive: true,
            height: "auto",
            width: 300
          }
        )
      }
      else
      {
      if (!this.currentItem.liked) {
        axios.put(
          "/playlist/" + this.currentItem.id_playlist + "/activity/lik"
        );
      }
      this.currentItem.liked = !this.currentItem.liked;
      axios.put("/playlist/" + this.currentItem.id_playlist + "/like");
    }
    },
    startBubbles(){
      if(this.$store.getters['user/data'].isPlaylistPopupShown==false && !this.isDefaultUser)
      {
        if(this.playlistCount>=6)
        {
          this.muted = true;
          this.dots.sixth = true;
        }
      }
      else if(this.isDefaultUser)
      {
        let viewed = localStorage.getItem('bubbles_shown');
        if(viewed==null)
        {
          this.muted = true;
          this.dots.sixth = true;
        }
      }
    }
  },
  mounted(){
  
  },
  created() {
    this.$store.commit("playlist/setViewed", []);
    this.id_category = this.$route.params.id_category?this.$route.params.id_category:null;
    window.fbq("track", "המשחק");
    // if(this.$store.getters['user/data'].isPlaylistPopupShown==false)
    // {
    //   this.muted = true;
    //   this.dots.sixth = true;
    // }

    if (!Object.keys(this.settings).length) {
      this.$store.commit("playlist/setSettings", {
        gender: "child",
        activities: ["1", "2", "3"],
        viewed_playlist: [],
        locations: this.$store.getters["playlist-locations/getByType"]("child")
          .filter((item) => item.is_default)
          .map((item) => {
            return item.id_setting;
          }),
        levels: [3, 2, 1],
        seen:[1,2]
      });
    }
    if(this.settings.seen==null || !this.settings.seen)
    {
      this.$store.commit("playlist/setDefaultSeen");
    }

    const init = async () => {
      let obj = JSON.parse(JSON.stringify(this.settings))
      await this.$store.commit("playlist/resetGames");
      await this.$store.dispatch('user/decreaseGamesCounter');
      await this.loadState();
       await this.getRandom({
        id_category: this.id_category,
        id_playlist: this.$route.params.id_playlist,
        neededCheck: false
      });
      this.setViewed();
      if(obj.viewed_playlist)
      {
        if(this.$store.getters["user/data"].subscribe_total_games == obj.viewed_playlist.length+1)
        {
          for(let i = 0; i<this.$store.getters["user/data"].subscribe_total_games-2; i++)
          {
            this.$store.commit("playlist/pushViewed", obj.viewed_playlist[i]);
          }
        }
        else
        {
          obj.viewed_playlist.forEach(element => {
          this.$store.commit("playlist/pushViewed", element);
        });
        }
      }
      await this.getRandom({id_category: this.id_category});
    };

    if (
      this.data.length &&
      this.data.filter((n) => n.state === "give-money").length ===
        this.data.length
    ) {
      this.$store.commit("playlist/resetGames");
    }

    if (!this.data.length || this.$route.params.id_playlist) {
      this.loading.sync = true;
      init().finally(() => {
        this.loading.sync = false;
      });
    }
  },
  beforeDestroy() {
    if (this.$store.getters["playlist/teacherViewed"]) {
      this.$store.commit("playlist/resetGames");
      this.$store.commit("playlist/setViewedT", []);
    }
  },
};
</script>

<style lang="scss" scoped>
.dots{
    display: inline-block;
    box-sizing: content-box;
    width: 6px !important; 
    height: 6px !important;
    border-radius: 50%;
    margin: 6px 3px;
}
.dots-simple{
    background-color: #D9D9D9;
    cursor: pointer;
}
.dots-active{
  width: 8px !important;
    height: 8px !important;
    background-color: #3FBCD4;
    cursor: pointer;
    margin: 5px 3px !important;
}

.buttons-info{
  display: inline-block;
  margin-left: 9px;
}
.controll-info{
  display: inline-block;
  text-align: left;
  .button-info{
    margin-left: 10px;
    margin-bottom: 10px;
    padding: 0px !important;
    width: 66px;
    height: 26px;
    background: #3FBCD4;
    border-radius: 2px;
    font-family: 'App';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: #FFFFFF;
  }
}
// .wrapper-popup{
//   position: fixed;
//   z-index: 9;
//   background: rgba(0, 0, 0, 0.25);
//   width: 100%;
//   height: 100vh;
//   right: 0;
//   top: 0;
// }
.help-popup-first {
  position: absolute;
    z-index: 10;
    bottom: 135px;
    left: 6px;
    width: 208px !important;
    height: 110px !important;
    border-radius: 10px;
    background: #FFFFFF;
    // border: 2px solid #3FBCD4;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  &:before {
    content: "";
    position: absolute;
    right: 45%;
    top: 101px;
    width: 18px;
    height: 18px;
    background: #FFFFFF;
    box-sizing: border-box;
    border-radius: 2px;
    transform: rotate(-45deg);
  }
  &.fade-scale {
    &-enter {
      opacity: 0;
      transform: scale(0.8);
    }
    &-enter-to {
      opacity: 1;
      transform: scale(1);
    }
    &-leave {
      opacity: 1;
      transform: scale(1);
    }
    &-leave-to {
      opacity: 0;
      transform: scale(0.8);
    }
    &-enter-active {
      transition: opacity 0.2s ease;
      transition: transform 0.2s cubic-bezier(0.635, 1.650, 0.410, 0.865);
    }

    &-leave-active {
      transition: opacity 0.2s ease;
      transition: transform 0.2s ease;
    }
  }
  .help-element{
   color: #01465B;
   margin-left: 12px;
   margin-top: 6px;
  }
  .info-element{
    padding: 20px 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 0 auto;
    width: 90%;
    font-size: 14px;
    color: #01465B;
    align-items: flex-start;
    span{
      max-width:150px;
      font-family: 'App';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
      text-align: center;
      margin-left: auto;
      margin-right: auto;

      color: #00465B !important;
     }
    @media screen and (max-width: 600px){
      font-size: 14px;
    }
    &.border{
      // border-bottom: 1px solid #B8EDFE;
    }
  }
  .close-b{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 140px;
    height: 36px;
    background: #3FBCD4;
    border-radius: 22px;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    color: #FFFFFF;
    margin: 20px auto;
  }
}
.wrapper-popup{
  position: fixed;
  z-index: 9;
  background: rgba(0, 0, 0, 0.25);
  width: 100%;
  height: 100vh;
  right: 0;
  top: 0;
  overflow: hidden;
}
.help-popup-second {
  pointer-events: all;
  position: absolute;
    z-index: 10;
    bottom: 135px;
    left: 6px;
    width: 208px !important;
    height: 110px !important;
    border-radius: 10px;
    background: #FFFFFF;
    // border: 2px solid #3FBCD4;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  &:before {
    content: "";
    position: absolute;
    right: 45%;
    top: 101px;
    width: 18px;
    height: 18px;
    background: #FFFFFF;
    box-sizing: border-box;
    border-radius: 2px;
    transform: rotate(-45deg);
  }
  &.fade-scale {
    &-enter {
      opacity: 0;
      transform: scale(0.8);
    }
    &-enter-to {
      opacity: 1;
      transform: scale(1);
    }
    &-leave {
      opacity: 1;
      transform: scale(1);
    }
    &-leave-to {
      opacity: 0;
      transform: scale(0.8);
    }
    &-enter-active {
      transition: opacity 0.2s ease;
      transition: transform 0.2s cubic-bezier(0.635, 1.650, 0.410, 0.865);
    }

    &-leave-active {
      transition: opacity 0.2s ease;
      transition: transform 0.2s ease;
    }
  }
  .help-element{
   color: #01465B;
   margin-left: 12px;
   margin-top: 6px;
  }
  .info-element{
    padding: 20px 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 0 auto;
    width: 90%;
    font-size: 14px;
    color: #01465B;
    align-items: flex-start;
    span{
      max-width:150px;
      font-family: 'App';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
      text-align: center;
      margin-left: auto;
      margin-right: auto;

      color: #00465B !important;
     }
    @media screen and (max-width: 600px){
      font-size: 14px;
    }
    &.border{
      // border-bottom: 1px solid #B8EDFE;
    }
  }
  .close-b{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 140px;
    height: 36px;
    background: #3FBCD4;
    border-radius: 22px;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    color: #FFFFFF;
    margin: 20px auto;
  }
}

.help-popup-fifth {
  pointer-events: all;
  position: absolute;
    z-index: 10;
    top: 50px;
    right: 6px;
    width: 300px !important;
    height: 160px !important;
    border-radius: 6px;
    background: #FFFFFF;
    // border: 2px solid #3FBCD4;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  &:before {
    content: "";
    content: "";
    position: absolute;
    right: 43%;
    top: -8px;
    width: 18px;
    height: 18px;
    background: #FFFFFF;
    box-sizing: border-box;
    border-radius: 2px;
    transform: rotate(-45deg);
  }
  &.fade-scale {
    &-enter {
      opacity: 0;
      transform: scale(0.8);
    }
    &-enter-to {
      opacity: 1;
      transform: scale(1);
    }
    &-leave {
      opacity: 1;
      transform: scale(1);
    }
    &-leave-to {
      opacity: 0;
      transform: scale(0.8);
    }
    &-enter-active {
      transition: opacity 0.2s ease;
      transition: transform 0.2s cubic-bezier(0.635, 1.650, 0.410, 0.865);
    }

    &-leave-active {
      transition: opacity 0.2s ease;
      transition: transform 0.2s ease;
    }
  }
  .help-element{
   color: #01465B;
   margin-left: 12px;
   margin-top: 6px;
  }
  .info-element{
    padding: 36px 0px 32px 0px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 0 auto;
    width: 90%;
    font-size: 14px;
    color: #01465B;
    align-items: flex-start;
    span{
      max-width:193px;
      margin: auto;
      font-family: 'App';
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 28px;
      /* or 156% */

      text-align: center;

      color: #00465B;

     }
    @media screen and (max-width: 600px){
      font-size: 14px;
    }
    &.border{
      // border-bottom: 1px solid #B8EDFE;
    }
  }
  .close-b{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 140px;
    height: 36px;
    background: #3FBCD4;
    border-radius: 22px;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    color: #FFFFFF;
    margin: 20px auto;
  }
}

.help-popup-sevens {
  pointer-events: all;
  position: absolute;
    z-index: 10;
    top: 190px;
    margin: auto;
    right: 0;
    left: 0;
    width: 300px !important;
    height: 180px !important;
    border-radius: 6px;
    background: #FFFFFF;
    // border: 2px solid #3FBCD4;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  
  &.fade-scale {
    &-enter {
      opacity: 0;
      transform: scale(0.8);
    }
    &-enter-to {
      opacity: 1;
      transform: scale(1);
    }
    &-leave {
      opacity: 1;
      transform: scale(1);
    }
    &-leave-to {
      opacity: 0;
      transform: scale(0.8);
    }
    &-enter-active {
      transition: opacity 0.2s ease;
      transition: transform 0.2s cubic-bezier(0.635, 1.650, 0.410, 0.865);
    }

    &-leave-active {
      transition: opacity 0.2s ease;
      transition: transform 0.2s ease;
    }
  }
  .help-element{
   color: #01465B;
   margin-left: 12px;
   margin-top: 6px;
  }
  .info-element{
    // padding: 20px 0;
    padding-bottom: 29px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 0 auto;
    width: 223px;
    font-size: 14px;
    color: #01465B;
    align-items: flex-start;
    span{
      // max-width:150px;
      font-family: 'App';
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 23px;
      text-align: center;
      margin-left: auto;
      margin-right: auto;

      color: #00465B !important;
     }
    @media screen and (max-width: 600px){
      font-size: 14px;
    }
    &.border{
      // border-bottom: 1px solid #B8EDFE;
    }
  }
  .close-b{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 140px;
    height: 36px;
    background: #3FBCD4;
    border-radius: 22px;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    color: #FFFFFF;
    margin: 20px auto;
  }
}



.bottom-skelet{
  background: rgba(130, 130, 130, 0.2);
     background: -webkit-gradient(linear, left top, right top, color-stop(8%, rgba(130, 130, 130, 0.2)), color-stop(18%, rgba(130, 130, 130, 0.3)), color-stop(33%, rgba(130, 130, 130, 0.2)));
     background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);
     background-size: 800px 100px;
     animation: wave-squares 2s infinite ease-out;
}
.circle {
     min-height: 100%;
     max-height: 100%;
     min-width: 100%;
     max-width: 100%;
     background: rgba(130, 130, 130, 0.2);
     background: -webkit-gradient(linear, left top, right top, color-stop(8%, rgba(130, 130, 130, 0.2)), color-stop(18%, rgba(130, 130, 130, 0.3)), color-stop(33%, rgba(130, 130, 130, 0.2)));
     background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);
     background-size: 800px 100px;
     animation: wave-squares 2s infinite ease-out;
}
.btn-skelet{
     background: rgba(130, 130, 130, 0.2);
     background: -webkit-gradient(linear, left top, right top, color-stop(8%, rgba(130, 130, 130, 0.2)), color-stop(18%, rgba(130, 130, 130, 0.3)), color-stop(33%, rgba(130, 130, 130, 0.2)));
     background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);
     background-size: 800px 100px;
     animation: wave-squares 2s infinite ease-out;
}
.btn-skelet-circle{
  background: rgba(130, 130, 130, 0.2);
     background: -webkit-gradient(linear, left top, right top, color-stop(8%, rgba(130, 130, 130, 0.2)), color-stop(18%, rgba(130, 130, 130, 0.3)), color-stop(33%, rgba(130, 130, 130, 0.2)));
     background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);
     background-size: 800px 100px;
     animation: wave-squares 2s infinite ease-out;
}
.line {
  
  position: absolute;
     height: 12px;
     left: 22px;
     width:100%;
      display:block;
     margin-bottom:6px;
     border-radius: 2px;
     background: rgba(130, 130, 130, 0.2);
     background: -webkit-gradient(linear, left top, right top, color-stop(8%, rgba(130, 130, 130, 0.2)), color-stop(18%, rgba(130, 130, 130, 0.3)), color-stop(33%, rgba(130, 130, 130, 0.2)));
     background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);
     background-size: 800px 100px;
     animation: wave-lines 2s infinite ease-out;
}
 
 .flex1{
    flex: 1;
}
 .flex2{
    flex: 2;
}
 .h8{
    height: 8px !important;
}
 .h10{
    height: 10px !important;
}
 .h12{
    height: 12px !important;
}
 .h15{
    height: 15px !important;
}
 .h17{
    height: 17px !important;
}
 .h20{
    height: 20px !important;
}
 .h25{
    height: 25px !important;
}
 .w25{
    width: 25% !important
}
 .w40{
    width:60% !important;
}
 .w50{
    width: 50% !important
}
 .w75{
    width: 75% !important
}
 .m10{
    margin-bottom: 10px !important;
}
 .circle{
  border-radius: 15px !important;
     height: 541px !important;
     width: 100% !important;
}
@media (max-height: 720px){
  .circle{
      border-radius: 15px !important;
     height: 400px !important;
     width: 100% !important;
  }
}
.btn-skelet{
  border-radius: 9999px !important;
     height: 42px !important;
     width: 140px !important;
}

.btn-skelet-circle{
  border-radius: 9999px !important;
     height: 42px !important;
     width: 40px !important;
}

.bottom-skelet{
  width: 100%;
  height: 70px;
}

 @keyframes wave-lines {
    0% {
        background-position: -468px 0;
    }
     100% {
        background-position: 468px 0;
    }
}
 @keyframes wave-squares {
    0% {
        background-position: -468px 0;
    }
     100% {
        background-position: 468px 0;
    }
}
.playlist {
  background: #00465B;
  padding-bottom: 0 !important;

  display: flex;
  flex-direction: column;

  .card-wrapper {
    // height: 450px;
    width: 100%;
    position: relative;
    z-index: 1;
    margin-bottom: 21px;
    cursor: grab;
    flex-grow: 1;
    &:active {
      cursor: grabbing;
    }
  }

  .app-loading {
    padding: 0 10px;
    flex-grow: 1;
    min-height: 450px;
    .settings-wrapper {
    }
  }

  .buttons {
    margin-bottom: 20px !important;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .prev {
      // margin-left: 20px !important;
      background-color: #FF5C5C;
      span {
        font-family: 'App';
font-style: normal;
font-weight: 400;
font-size: 15px;
line-height: 20px;
text-align: center;

color: #06364B;
      }
      width: 120px;
      height: 40px;
    }

    .next {
      // margin-right: 20px !important;
      background-color: #8CC63F;

      width: 120px;
      height: 40px;
      span {
        font-family: 'App';
font-style: normal;
font-weight: 400;
font-size: 15px;
line-height: 20px;
text-align: center;

color: #06364B;
      }
    }
  }

  .small-white {
    position: absolute;
    left: 15px;
    color: #fff;
    font-size: 12px;
  }
}
</style>
